var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplePayLogoChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 47.196 20.021"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ApplePayLogoChecked_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ApplePayLogoChecked_svg__Rectangle_4",
    "data-name": "Rectangle 4",
    className: "ApplePayLogoChecked_svg__cls-1",
    d: "M0 0h47.196v20.021H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".ApplePayLogoChecked_svg__cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ApplePayLogoChecked_svg__Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ApplePayLogoChecked_svg__Group_4",
    "data-name": "Group 4",
    clipPath: "url(#ApplePayLogoChecked_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ApplePayLogoChecked_svg__Path_10",
    "data-name": "Path 10",
    className: "ApplePayLogoChecked_svg__cls-1",
    d: "M19 2.582A3.622 3.622 0 0019.832 0a3.592 3.592 0 00-2.381 1.232 3.39 3.39 0 00-.851 2.482A3 3 0 0019 2.582",
    transform: "translate(-10.078)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ApplePayLogoChecked_svg__Path_11",
    "data-name": "Path 11",
    className: "ApplePayLogoChecked_svg__cls-1",
    d: "M9.743 9.919c-1.326-.079-2.454.753-3.087.753S5.053 9.959 4 9.978A3.91 3.91 0 00.679 12c-1.424 2.453-.379 6.1 1.01 8.1.673.99 1.484 2.079 2.552 2.04 1.01-.04 1.405-.654 2.632-.654s1.583.654 2.652.634c1.108-.02 1.8-.99 2.474-1.981a8.776 8.776 0 001.108-2.277 3.6 3.6 0 01-2.156-3.267 3.665 3.665 0 011.741-3.069 3.792 3.792 0 00-2.949-1.6",
    transform: "translate(0 -6.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ApplePayLogoChecked_svg__Path_12",
    "data-name": "Path 12",
    className: "ApplePayLogoChecked_svg__cls-1",
    d: "M45.664 2.889a4.66 4.66 0 014.889 4.879 4.712 4.712 0 01-4.961 4.9H42.4v5.075h-2.3V2.889zM42.4 10.732h2.645c2.007 0 3.15-1.081 3.15-2.954s-1.142-2.944-3.139-2.944H42.4z",
    transform: "translate(-24.375 -1.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ApplePayLogoChecked_svg__Path_13",
    "data-name": "Path 13",
    className: "ApplePayLogoChecked_svg__cls-1",
    d: "M68.305 20.6c0-1.894 1.451-3.057 4.025-3.2l2.964-.175v-.834c0-1.2-.813-1.925-2.172-1.925a2.073 2.073 0 00-2.285 1.585h-2.1c.123-1.956 1.791-3.4 4.467-3.4 2.624 0 4.3 1.389 4.3 3.562v7.463h-2.13V21.9h-.051a3.868 3.868 0 01-3.417 1.966 3.282 3.282 0 01-3.6-3.263m6.989-.978v-.854l-2.666.165c-1.328.093-2.079.679-2.079 1.606 0 .947.782 1.564 1.976 1.564a2.6 2.6 0 002.769-2.481",
    transform: "translate(-41.525 -7.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ApplePayLogoChecked_svg__Path_14",
    "data-name": "Path 14",
    className: "ApplePayLogoChecked_svg__cls-1",
    d: "M95.246 27.965v-1.8a4.107 4.107 0 00.72.041 1.8 1.8 0 001.925-1.544c0-.02.2-.659.2-.669l-3.916-10.84h2.408l2.738 8.811h.041l2.738-8.811h2.347l-4.056 11.395c-.926 2.625-2 3.469-4.241 3.469a8.648 8.648 0 01-.906-.051",
    transform: "translate(-57.252 -7.996)"
  })))));
}
export default __webpack_public_path__ + "74ca8aa4adb5615111838e0cd422cfa0.svg";
export { SvgApplePayLogoChecked as ReactComponent };